module.exports = __webpack_public_path__ + "img/EURUSD.21865326.png";